export default "__VITE_ASSET__BDIH5I9t__"